import { request } from 'root/common/request';
import PrivilegeState from 'root/common/thirdParty/privilege/state';
import Config from 'root/common/config/config';
import url from './url';
import env from '@/common/util/env';
import {
    transformRechargeDetailApi,
    transformOrderDetailApi,
    transformPayFinishApi,
    transformActivityVerifyApi,
} from './apiTransform';
// import { isJobConvenienceAliMini, getAlipayMiniAppId } from '@/common/util/miniEnv';
import { getAlipayMiniAppId, isJobConvenienceAliMini } from '@/common/util/miniEnv';

export function getRechargeInfo({ id, ...option }) {
    return request({
        url: Config.api.getRechargeInfo,
        params: {
            id,
            ...option,
        },
        isNeedToken: false,
    });
}

export function getRechargeInfoV2({ id, ...option }) {
    return request({
        url: Config.api.tqcz.getRechargeInfoV2,
        params: PrivilegeState.inject({
            id,
            ...option,
        }),
        isNeedToken: false,
    }).then(res => {
        return transformRechargeDetailApi(res);
    });
}

export function saveSkuId({ sku_id, account, app_pay, ...option }) {
    return request({
        url: Config.api.saveSkuId,
        params: {
            sku_id,
            account,
            app_pay,
            ...option,
        },
        isNeedToken: false,
    });
}

// 创建订单
export function saveSkuIdV2({ shareHash, sku_id, account, app_pay, ...option }) {
    //  针对校园小程序
    let data = {};
    if (env.isCommunityMiniProgram) {
        data.miniAppId = window?.localStorage?.getItem('wechatMiniProgramAppId');
    }
    if (isJobConvenienceAliMini) {
        data.appId = getAlipayMiniAppId();
        data.source = 'aliCareer';
    }
    const parmas = {
        shareHash,
        skuId: sku_id,
        account,
        app_pay,
        ...option,
        ...data,
    };
    if (!isJobConvenienceAliMini) {
        Reflect.deleteProperty(parmas, 'source');
    }
    return request({
        url: Config.api.tqcz.tqczPay,
        method: 'POST',
        data: PrivilegeState.inject(parmas),
        isNeedToken: false,
    });
}

export function getOrderInfo({ order_id, ...option }) {
    return request({
        url: Config.api.getOrderInfo,
        params: {
            order_id,
            orderId: order_id,
            ...option,
        },
        isNeedToken: false,
    }).then(res => {
        return transformPayFinishApi(res);
    });
}

export function getOrderPayStatus({ order_id }) {
    return request({
        url: Config.api.getOrderPayStatus,
        params: {
            order_id,
            orderId: order_id,
        },
        isNeedLoading: false,
        isNeedToken: false,
    });
}

export function andriodWechatPay({ url }) {
    return request({
        url,
        params: {},
        isNeedToken: false,
    });
}

export function getTqczDetail(params) {
    return request({
        url: Config.api.getTqczDetail,
        params,
    }).then(res => {
        return transformOrderDetailApi(res);
    });
}

/**
 * 新收银台app支付
 *
 * @date 2019-06-11
 * @export
 * @param {*} { order_id, app, type } app参数为（alipayApp,weixinApp之一），type(card,recharge,hero三个参数之一), opendid可选
 * @returns
 */
export function getAppPayInfo({ order_id, app, type }) {
    return request({
        url: Config.api.getAppPayInfo,
        params: {
            order_id,
            app,
            type,
        },
    });
}

/**
 * 待支付渲染接口
 * @param {*} param
 */
export function getWaitForPay({ orderId }) {
    console.log('orderId: ', orderId);
    return request({
        url: Config.api.tqcz.waitForPay,
        params: {
            orderId,
        },
    });
}

/**
 * 判断是否活动价格
 *
 * @date 2020-03-11
 * @export
 * @param {*} { skuId, account }
 * @returns
 */
export function getRechargeActivityVerify({ skuId, account }) {
    return request({
        url: Config.api.tqcz.rechargeActivityVerify,
        params: {
            skuId,
            account,
        },
    }).then(res => {
        return transformActivityVerifyApi(res);
    });
}

export function getAutoPickCoupon(params) {
    return request({
        url: Config.api.tqcz.autoPickCoupon,
        params,
    });
}

// 查询金卡信息
export function getGoldCardInfo(data) {
    return request({
        url: url.getGoldCardInfo,
        method: 'POST',
        data,
        isNeedLoading: false,
        isNeedToken: true,
    });
}

// 创建金卡订单
export function createyGoldCardOrder(data) {
    return request({
        url: url.createGoldCardOrder,
        method: 'POST',
        data,
        isNeedLoading: true,
        isNeedToken: true,
    });
}

// 订单支付状态查询
export function queryGoldCardOrder(data) {
    return request({
        url: url.queryGoldCardPay,
        method: 'POST',
        data,
        isNeedLoading: false,
        isNeedToken: true,
    });
}

// 支付宝学生认证
export function alipayIdentityCert(params) {
    return request({
        url: url.alipayIdentityVerify,
        method: 'get',
        params,
        isNeedLoading: true,
        isNeedToken: true,
    });
}

// 支付宝学生认证
export function getOrderPayInfo(params) {
    return request({
        url: url.getOrderPayInfo,
        method: 'get',
        params,
        isNeedLoading: false,
        isNeedToken: true,
    });
}
